export enum StatusNotificacao {
  RASCUNHO = 'RASCUNHO',
  AGUARDANDO_ENVIO = 'AGUARDANDO_ENVIO',
  AGENDADA = 'AGENDADA',
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  ENVIANDO = 'ENVIANDO',
  ENVIADA = 'ENVIADA',
  PARCIALMENTE_ENVIADA = 'PARCIALMENTE_ENVIADA',
  FALHA_ENVIO = 'FALHA_ENVIO',
  ENTREGUE = 'ENTREGUE',
  PARCIALMENTE_ENTREGUE = 'PARCIALMENTE_ENTREGUE',
  VISUALIZADA = 'VISUALIZADA',
  EM_NEGOCIACAO = 'EM_NEGOCIACAO',
  CONCLUIDA = 'CONCLUIDA',
  CANCELADA = 'CANCELADA',
  ARQUIVADA = 'ARQUIVADA',
  REENVIADA = 'REENVIADA',
}

export enum StatusEmail {
  PENDENTE = 'PENDENTE',
  ENVIADO = 'ENVIADO',
  ENTREGUE = 'ENTREGUE',
  VISUALIZADO = 'VISUALIZADO',
  FALHA = 'FALHA',
  BOUNCE = 'BOUNCE',
  SPAM = 'SPAM',
  CANCELADO = 'CANCELADO',
  BLOQUEADO = 'BLOQUEADO',
}

export enum StatusWhatsApp {
  PENDENTE = 'PENDENTE',
  ENVIADO = 'ENVIADO',
  ENTREGUE = 'ENTREGUE',
  VISUALIZADO = 'VISUALIZADO',
  RESPONDIDO = 'RESPONDIDO',
  FALHA = 'FALHA',
  CANCELADO = 'CANCELADO',
  BLOQUEADO = 'BLOQUEADO',
}

export enum StatusCorreios {
  PENDENTE = 'PENDENTE',
  EM_PRODUCAO = 'EM_PRODUCAO',
  POSTADO = 'POSTADO',
  EM_TRANSITO = 'EM_TRANSITO',
  SAIU_PARA_ENTREGA = 'SAIU_PARA_ENTREGA',
  ENTREGUE = 'ENTREGUE',
  RECUSADO = 'RECUSADO',
  ENDERECO_INVALIDO = 'ENDERECO_INVALIDO',
  AUSENTE = 'AUSENTE',
  DEVOLVIDO = 'DEVOLVIDO',
  CANCELADO = 'CANCELADO',
}

export enum EventoAcesso {
  ACESSO_REGISTRADO = 'ACESSO_REGISTRADO',
  ABERTURA_VALIDADA = 'ABERTURA_VALIDADA',
  TENTATIVA_ACESSO_FALHA = 'TENTATIVA_ACESSO_FALHA',
  CONTEUDO_VISUALIZADO = 'CONTEUDO_VISUALIZADO',
  DOCUMENTO_BAIXADO = 'DOCUMENTO_BAIXADO',
  QRCODE_ESCANEADO = 'QRCODE_ESCANEADO',
}

export type StatusNotificacaoVariant = 'neutral' | 'success' | 'error' | 'brand' | 'warning';

interface StatusConfig {
  label: string;
  cor: string;
  variant: StatusNotificacaoVariant;
}

export const STATUS_NOTIFICACAO_CONFIG: Record<StatusNotificacao, StatusConfig> = {
  [StatusNotificacao.RASCUNHO]: { label: 'Rascunho', cor: 'gray', variant: 'neutral' },
  [StatusNotificacao.AGUARDANDO_ENVIO]: {
    label: 'Aguardando Envio',
    cor: 'blue',
    variant: 'brand',
  },
  [StatusNotificacao.AGENDADA]: { label: 'Agendada', cor: 'yellow', variant: 'warning' },
  [StatusNotificacao.EM_PROCESSAMENTO]: {
    label: 'Em Processamento',
    cor: 'purple',
    variant: 'brand',
  },
  [StatusNotificacao.ENVIANDO]: { label: 'Enviando', cor: 'blue', variant: 'brand' },
  [StatusNotificacao.ENVIADA]: { label: 'Enviada', cor: 'purple', variant: 'brand' },
  [StatusNotificacao.PARCIALMENTE_ENVIADA]: {
    label: 'Parcialmente Enviada',
    cor: 'yellow',
    variant: 'warning',
  },
  [StatusNotificacao.FALHA_ENVIO]: { label: 'Falha no Envio', cor: 'red', variant: 'error' },
  [StatusNotificacao.ENTREGUE]: { label: 'Entregue', cor: 'green', variant: 'success' },
  [StatusNotificacao.PARCIALMENTE_ENTREGUE]: {
    label: 'Parcialmente Entregue',
    cor: 'yellow',
    variant: 'warning',
  },
  [StatusNotificacao.VISUALIZADA]: { label: 'Visualizada', cor: 'teal', variant: 'success' },
  [StatusNotificacao.EM_NEGOCIACAO]: { label: 'Em Negociação', cor: 'purple', variant: 'brand' },
  [StatusNotificacao.CONCLUIDA]: { label: 'Concluída', cor: 'green', variant: 'success' },
  [StatusNotificacao.CANCELADA]: { label: 'Cancelada', cor: 'gray', variant: 'neutral' },
  [StatusNotificacao.ARQUIVADA]: { label: 'Arquivada', cor: 'gray', variant: 'neutral' },
  [StatusNotificacao.REENVIADA]: { label: 'Reenviada', cor: 'purple', variant: 'brand' },
};

const STATUS_EMAIL_CONFIG: Record<StatusEmail, StatusConfig> = {
  [StatusEmail.PENDENTE]: { label: 'Pendente', cor: 'gray', variant: 'neutral' },
  [StatusEmail.ENVIADO]: { label: 'Email Enviado', cor: 'blue', variant: 'brand' },
  [StatusEmail.ENTREGUE]: { label: 'Email Entregue', cor: 'green', variant: 'success' },
  [StatusEmail.VISUALIZADO]: { label: 'Email Visualizado', cor: 'teal', variant: 'success' },
  [StatusEmail.FALHA]: { label: 'Email Falha', cor: 'red', variant: 'error' },
  [StatusEmail.BOUNCE]: { label: 'Email Bounce', cor: 'red', variant: 'error' },
  [StatusEmail.SPAM]: { label: 'Email Spam/Quarentena', cor: 'yellow', variant: 'warning' },
  [StatusEmail.CANCELADO]: { label: 'Email Cancelado', cor: 'gray', variant: 'neutral' },
  [StatusEmail.BLOQUEADO]: { label: 'Não entregue', cor: 'red', variant: 'error' },
};

const STATUS_WHATSAPP_CONFIG: Record<StatusWhatsApp, StatusConfig> = {
  [StatusWhatsApp.PENDENTE]: { label: 'Pendente', cor: 'gray', variant: 'neutral' },
  [StatusWhatsApp.ENVIADO]: { label: 'WhatsApp Enviado', cor: 'blue', variant: 'brand' },
  [StatusWhatsApp.ENTREGUE]: { label: 'WhatsApp Entregue', cor: 'green', variant: 'success' },
  [StatusWhatsApp.VISUALIZADO]: { label: 'WhatsApp Visualizado', cor: 'teal', variant: 'success' },
  [StatusWhatsApp.RESPONDIDO]: { label: 'WhatsApp Respondido', cor: 'purple', variant: 'brand' },
  [StatusWhatsApp.FALHA]: { label: 'WhatsApp Falha', cor: 'red', variant: 'error' },
  [StatusWhatsApp.CANCELADO]: { label: 'WhatsApp Cancelado', cor: 'gray', variant: 'neutral' },
  [StatusWhatsApp.BLOQUEADO]: { label: 'Não entregue', cor: 'red', variant: 'error' },
};

const STATUS_CORREIOS_CONFIG: Record<StatusCorreios, StatusConfig> = {
  [StatusCorreios.PENDENTE]: { label: 'Pendente', cor: 'gray', variant: 'neutral' },
  [StatusCorreios.EM_PRODUCAO]: { label: 'Em Produção', cor: 'purple', variant: 'brand' },
  [StatusCorreios.POSTADO]: { label: 'Postado', cor: 'blue', variant: 'brand' },
  [StatusCorreios.EM_TRANSITO]: { label: 'Em Trânsito', cor: 'blue', variant: 'brand' },
  [StatusCorreios.SAIU_PARA_ENTREGA]: { label: 'Saiu para Entrega', cor: 'blue', variant: 'brand' },
  [StatusCorreios.ENTREGUE]: { label: 'Entregue', cor: 'green', variant: 'success' },
  [StatusCorreios.RECUSADO]: { label: 'Recusado', cor: 'orange', variant: 'warning' },
  [StatusCorreios.ENDERECO_INVALIDO]: { label: 'Endereço Inválido', cor: 'red', variant: 'error' },
  [StatusCorreios.AUSENTE]: { label: 'Ausente', cor: 'yellow', variant: 'warning' },
  [StatusCorreios.DEVOLVIDO]: { label: 'Devolvido ao Remetente', cor: 'red', variant: 'error' },
  [StatusCorreios.CANCELADO]: { label: 'Cancelado', cor: 'gray', variant: 'neutral' },
};

export const EVENTO_ACESSO_CONFIG: Record<EventoAcesso, StatusConfig> = {
  [EventoAcesso.ACESSO_REGISTRADO]: { label: 'Acesso Registrado', cor: 'blue', variant: 'brand' },
  [EventoAcesso.ABERTURA_VALIDADA]: {
    label: 'Abertura Validada',
    cor: 'green',
    variant: 'success',
  },
  [EventoAcesso.TENTATIVA_ACESSO_FALHA]: {
    label: 'Tentativa de Acesso Falhou',
    cor: 'red',
    variant: 'error',
  },
  [EventoAcesso.CONTEUDO_VISUALIZADO]: {
    label: 'Conteúdo Visualizado',
    cor: 'teal',
    variant: 'success',
  },
  [EventoAcesso.DOCUMENTO_BAIXADO]: { label: 'Documento Baixado', cor: 'purple', variant: 'brand' },
  [EventoAcesso.QRCODE_ESCANEADO]: { label: 'QR Code Escaneado', cor: 'blue', variant: 'brand' },
};

export const getStatusNotificacaoLabel = (status: StatusNotificacao): string => {
  return STATUS_NOTIFICACAO_CONFIG[status]?.label || status;
};

export const getStatusNotificacaoVariant = (
  status: StatusNotificacao,
): StatusNotificacaoVariant => {
  return STATUS_NOTIFICACAO_CONFIG[status]?.variant || 'neutral';
};

export const getStatusEmailLabel = (status: StatusEmail): string => {
  return STATUS_EMAIL_CONFIG[status]?.label || status;
};

export const getStatusEmailVariant = (status: StatusEmail): StatusNotificacaoVariant => {
  return STATUS_EMAIL_CONFIG[status]?.variant || 'neutral';
};

export const getStatusWhatsAppLabel = (status: StatusWhatsApp): string => {
  return STATUS_WHATSAPP_CONFIG[status]?.label || status;
};

export const getStatusWhatsAppVariant = (status: StatusWhatsApp): StatusNotificacaoVariant => {
  return STATUS_WHATSAPP_CONFIG[status]?.variant || 'neutral';
};

export const getStatusCorreiosLabel = (status: StatusCorreios): string => {
  return STATUS_CORREIOS_CONFIG[status]?.label || status;
};

export const getStatusCorreiosVariant = (status: StatusCorreios): StatusNotificacaoVariant => {
  return STATUS_CORREIOS_CONFIG[status]?.variant || 'neutral';
};

export const getEventoAcessoLabel = (evento: EventoAcesso): string => {
  return EVENTO_ACESSO_CONFIG[evento]?.label || evento;
};

export const getEventoAcessoVariant = (evento: EventoAcesso): StatusNotificacaoVariant => {
  return EVENTO_ACESSO_CONFIG[evento]?.variant || 'neutral';
};

type CanalNormalized = 'EMAIL' | 'WHATSAPP' | 'CORREIOS';

const CANAL_MAP: Record<string, CanalNormalized> = {
  email: 'EMAIL',
  whatsapp: 'WHATSAPP',
  fisico: 'CORREIOS',
  correios: 'CORREIOS',
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP',
  CORREIOS: 'CORREIOS',
};

const normalizeCanal = (canal: string): CanalNormalized | undefined => {
  return CANAL_MAP[canal];
};

const TECHNICAL_STATUS_MAP: Record<string, string> = {
  // Eventos da trilha probatória do certificado arbitral (fluxo de citação Lexi via
  // WhatsApp), não códigos de status de entrega — chegam aqui como `resultado` da
  // tentativa (o back manda o evento CRU, só o traduz no campo `evento` das linhas do
  // certificado). Sem entrada, `matchByIncludes` não reconhece nenhum e o resultado no
  // topo do card de auditoria ficava cru ("CIENCIA_CONFIRMADA", "M02_ABORDAGEM_INICIAL").
  CIENCIA_CONFIRMADA: 'Ciência confirmada',
  M02_ABORDAGEM_INICIAL: 'Abordagem inicial enviada',
  UNDELIVERABLE_NOT_DELIVERED: 'Não entregue',
  UNDELIVERABLE_REJECTED_OPERATOR: 'Não entregue (rejeitado pela operadora)',
  UNDELIVERABLE_REJECTED_PREFIX: 'Não entregue (número inválido)',
  UNDELIVERABLE_REJECTED_TERM_OF_SERVICE: 'Não entregue (violação de termos)',
  UNDELIVERABLE_UNREGISTERED: 'Não entregue (número não registrado)',
  UNDELIVERABLE: 'Não entregue',
  BOUNCE_HARD: 'Email não entregue (endereço inválido)',
  BOUNCE_SOFT: 'Email não entregue temporariamente',
  BOUNCE: 'Voltou',
  REJECTED: 'Rejeitado',
  COMPLAINT: 'Marcado como SPAM',
  SPAM: 'Bloqueado',
  SEEN: 'Visualizado',
  READ: 'Visualizado',
  DELIVERED: 'Entregue',
  DELIVERED_TO_HANDSET: 'Entregue',
  SENT: 'Enviado',
  PENDING: 'Pendente',
  FAILED: 'Falhou',
  QUEUED: 'Na fila',
  ACCEPTED: 'Aceito',
  OPENED: 'Aberto',
  CLICKED: 'Clicado',
  // Evento do envio RCS (Pontaltech): o aparelho não recebe RCS e a mensagem saiu pelo SMS nativo.
  FALLBACK_SMS: 'Sem RCS no aparelho: enviado por SMS',
  // O notificado escreveu na conversa RCS. Não é manifestação; se conta como ciência, quem decide
  // é a régua do back (no WhatsApp, `RESPONDIDO` conta), não este rótulo.
  REPLIED: 'Respondeu na conversa',
};

const normalizeStatusText = (status: string): string => {
  return status
    .trim()
    .replace(/^webhook\s+/i, '')
    .replace(/^api\s+/i, '')
    .replace(/^event\s+/i, '');
};

const matchByIncludes = (lowered: string): string | undefined => {
  if (lowered.includes('undeliverable')) return 'Não entregue';
  if (lowered.includes('não entregue')) return 'Não entregue';
  if (lowered.includes('sent') || lowered.includes('enviado')) return 'Enviado';
  if (lowered.includes('delivered') || lowered.includes('entregue')) return 'Entregue';
  if (lowered.includes('read') || lowered.includes('lido') || lowered.includes('visualiz'))
    return 'Visualizado';
  if (lowered.includes('rejected')) return 'Rejeitado';
  if (lowered.includes('failed') || lowered.includes('falha') || lowered.includes('erro'))
    return 'Falha';
  if (lowered.includes('pending') || lowered.includes('pendente')) return 'Pendente';
  if (lowered.includes('bounce')) return 'Email não entregue (Bounce)';
  if (lowered.includes('spam')) return 'Email em SPAM';
  if (lowered.includes('postado')) return 'Postado';
  if (lowered.includes('transito') || lowered.includes('transit')) return 'Em trânsito';
  return undefined;
};

export const humanizeStatus = (status: string, canal?: string): string => {
  const normalized = normalizeStatusText(status);
  const upperStatus = normalized.toUpperCase();
  const resolvedCanal = canal ? normalizeCanal(canal) : undefined;

  if (resolvedCanal === 'EMAIL' && upperStatus in StatusEmail) {
    return getStatusEmailLabel(upperStatus as StatusEmail);
  }

  if (resolvedCanal === 'WHATSAPP' && upperStatus in StatusWhatsApp) {
    return getStatusWhatsAppLabel(upperStatus as StatusWhatsApp);
  }

  if (resolvedCanal === 'CORREIOS' && upperStatus in StatusCorreios) {
    return getStatusCorreiosLabel(upperStatus as StatusCorreios);
  }

  if (resolvedCanal === 'CORREIOS' && normalized.split(/\s+/).length > 2) {
    return normalized;
  }

  if (TECHNICAL_STATUS_MAP[upperStatus]) {
    return TECHNICAL_STATUS_MAP[upperStatus];
  }

  return matchByIncludes(normalized.toLowerCase()) ?? normalized;
};

// Labels/variants de Correios usados pelo painel da secretaria arbitral e pelo Certificado de
// Acessos — fonte única para não divergir entre telas que exibem o mesmo status.
export const STATUS_CORREIOS_LABELS: Record<string, string> = {
  AGUARDANDO_AUTORIZACAO: 'Aguardando autorização',
  PENDENTE: 'Pendente',
  POSTADO: 'Postado',
  EM_TRANSITO: 'Em trânsito',
  SAIU_PARA_ENTREGA: 'Saiu para entrega',
  ENTREGUE: 'Entregue (assinado)',
  RECUSADO: 'Recusado',
  ENDERECO_INVALIDO: 'Endereço inválido',
  AUSENTE: 'Ausente',
  DEVOLVIDO: 'Devolvido',
  CANCELADO: 'Cancelado',
  EM_PRODUCAO: 'Em produção',
};

export const STATUS_CORREIOS_VARIANTS: Record<string, StatusNotificacaoVariant> = {
  AGUARDANDO_AUTORIZACAO: 'warning',
  PENDENTE: 'neutral',
  POSTADO: 'brand',
  EM_TRANSITO: 'brand',
  SAIU_PARA_ENTREGA: 'brand',
  ENTREGUE: 'success',
  RECUSADO: 'error',
  ENDERECO_INVALIDO: 'error',
  AUSENTE: 'warning',
  DEVOLVIDO: 'warning',
  CANCELADO: 'neutral',
  EM_PRODUCAO: 'brand',
};
